import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
//获取发现列表接口
export function selectFindListBySearch(data){
	return post('/admin/appCFind/selectFindListBySearch',data)
}
// 查询traderGoodsId
export function appCGoodsInfoByGoodsId(data){
	return post('/admin/appCGoods/appCGoodsInfoByGoodsId',data)
}